import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AdminState } from "./admin.reducer";

export const adminFeatureKey = 'adminFeatureKey';
export const selectAdminFeature = createFeatureSelector<AdminState>(
    adminFeatureKey
)

export const selectRemarksData = createSelector(
    selectAdminFeature,
    state => state.remarksData
)
